import { render, staticRenderFns } from "./DeliveriesModal.vue?vue&type=template&id=31ad8733&scoped=true&"
import script from "./DeliveriesModal.vue?vue&type=script&lang=js&"
export * from "./DeliveriesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ad8733",
  null
  
)

export default component.exports